import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './assets/fonts/index.css';
import * as Sentry from '@sentry/react';
import { SENTRY_DSN, SENTRY_ENV } from './defines';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import changelog from './changelog.json';

const sentryBeforeSendEvent = (event: any) => {
  if (event.level !== 'fatal' && event.level !== 'error') {
    return null;
  }
  return event;
};

Sentry.init({
  dsn: SENTRY_DSN,
  release: changelog?.versions?.[0]?.version || '1.0.0',
  environment: SENTRY_ENV,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
  // debug: !isProductionEnvironment,
  beforeSend: sentryBeforeSendEvent,
});

const RootNode = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(RootNode());
export { SECRET_ACCESS_KEY } from './defines';
export { ACCESS_KEY } from './defines';
export { REGION } from './defines';
export { S3_BUCKET_NAMES } from './defines';
